import { render } from "./uploadAudio.vue?vue&type=template&id=5f4b89f5&scoped=true"
import script from "./uploadAudio.vue?vue&type=script&lang=js"
export * from "./uploadAudio.vue?vue&type=script&lang=js"

import "./uploadAudio.vue?vue&type=style&index=0&id=5f4b89f5&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4b89f5"],['__file',"src/components/uploadAudio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f4b89f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f4b89f5', __exports__)) {
    api.reload('5f4b89f5', __exports__)
  }
  
  module.hot.accept("./uploadAudio.vue?vue&type=template&id=5f4b89f5&scoped=true", () => {
    api.rerender('5f4b89f5', render)
  })

}


export default __exports__